export var EVENT_BACKGROUND_OPACITY = 0.5;
export var DEMO_CALENDARS_IDS = ['calendar1', 'calendar2', 'calendar3'];
export var DEFAULT_TIMEZONE = 'America/New_York';
export var EVELABLE_LOCALES = [
    'ar',
    'bg',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'fi',
    'fr',
    'hr',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'ms',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'vi',
    'zh',
];
//# sourceMappingURL=index.js.map